import moduleDrilling from "../../store/moduleDrilling.js";
import companySideView from "./components/companySideView.vue"

export default {
  components: {
    companySideView
  },
  data() {
    return {
      selectedMainProjectId: null,
      sidebarActive: false,
      sidebarData: {}
    };
  },

  computed: {
    companies() {
      return this.$store.state.drilling.companies;
    }
  },
  mounted() {
    this.$vs.loading();
    this.$store.dispatch("drilling/fetchAllCompanies").then(() => {
      this.$refs.listCard.refreshcard();
    }).finally(() => {
      this.$vs.loading.close();
    })    
  },
  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }
  },
  methods: {
    addCompany() {
      this.sidebarData = {};
      this.toggleSidebar(true);
    },
    editCompany(company) {
      this.sidebarData = company;
      this.toggleSidebar(true);
    },
    toggleSidebar(val = false) {
      this.sidebarActive = val;
    },
    onUpdated() {
      this.$notifySaveSuccess();
      this.toggleSidebar(false);
    },

    onInserted() {
      this.$notifySaveSuccess();
      this.toggleSidebar(false);
    },
  
    getCompanies() {
      this.$store.dispatch("drilling/fetchAllCompanies").finally(() => {
        this.$refs.listCard.removeRefreshAnimation()
      });
    },

    openDeleteConfirm(companyId) {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Companies.ConfirmDelete'),
        accept: () => this.deleteCompany(companyId)
      });
    },

    deleteCompany(id) {
      this.$store.dispatch("drilling/removeCompany", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Drilling.Companies.CompanyDeleted"));
          this.$refs.listCard.refreshcard();
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.listCard.refreshcard();
          }
        });
    }
  }
};
